import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()

export class LoginService {

	public baseUrl: string;

	constructor(private _http: Http) {
		this.baseUrl = environment.apiUrl;
	}

	login(login: any) { // login service
		let json = JSON.stringify(login);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');

		return this._http.post(this.baseUrl + 'login', json, { headers: headers })
			.map(res => res.json());
	}

	listModule(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'ListUserModule/' + data.email, { headers: headers })
			.map(res => res.json());
	}

	validate(token: any) { // validates if the session token is still valid.
		let json = JSON.stringify(token);
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + token.auth_token);
		headers.append('Content-Type', 'application/json');
		headers.append('Access-Control-Allow-Origin', '*');
		return this._http.post(this.baseUrl + 'valid', json, { headers: headers })
			.map(res => res.json());
	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/auth/login/login.service.ts